module.exports = __webpack_public_path__ + "img/img29.ac406585.png";